import { commonApis } from '@/configs/apis/common';
import { MyEventTarget } from '@/scripts/extends';
import { exportApis } from '@/scripts/utils/devUtils';
import { STLocalStorage } from '@/configs/storages/browser';
import { SysConsts } from './types';

export class ServerTime extends MyEventTarget<{ sync: number }> {
  private static instance: ServerTime = new ServerTime();
  server: number = STLocalStorage.getItem('server') || Date.now();
  local: number = STLocalStorage.getItem('local') || Date.now();
  initPromise!: Promise<void>;
  private timeId: any;
  private isOuted = false;
  constructor() {
    if (ServerTime.instance) {
      return ServerTime.instance;
    } else {
      super();
      this.initPromise = this.syncServerTime();
      this.initEvents();
      ServerTime.instance = this;
    }
  }
  async syncServerTime(retryCount = 0) {
    try {
      this.server = await commonApis.getSystemDate();
      this.local = Date.now();

      STLocalStorage.setItem('server', this.server);
      STLocalStorage.setItem('local', this.local);

      this.dispatchEvent('sync', this.server);

      clearTimeout(this.timeId);
      this.timeId = setTimeout(() => {
        this.syncServerTime();
      }, SysConsts.SYNC_INTERVAL);
    } catch (error) {
      if (retryCount < SysConsts.MAX_RETRY_ATTEMPTS) {
        await new Promise((resolve) => setTimeout(resolve, SysConsts.RETRY_DELAY));
        await this.syncServerTime(retryCount + 1);
      } else {
        throw error;
      }
    }
  }
  initEvents() {
    window.addEventListener('blur', () => {
      this.isOuted = true;
    });
    window.addEventListener('focus', () => {
      if (this.isOuted) {
        this.syncServerTime();
        this.isOuted = false;
      }
    });
  }
  get time() {
    return this.server + Date.now() - this.local;
  }
}

export const serverTime = new ServerTime();

exportApis({ serverTime });
